var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCdp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.268 11.129a.273.273 0 01.464 0l1.208 2.062c.076.13.21.221.367.249l2.477.432c.206.036.288.272.143.415l-1.728 1.702a.478.478 0 00-.142.406l.324 2.324c.027.195-.186.34-.375.257l-2.28-1.008a.561.561 0 00-.452 0l-2.28 1.008c-.19.084-.402-.062-.375-.257l.324-2.324a.478.478 0 00-.142-.406l-1.728-1.702c-.145-.143-.063-.38.143-.415l2.477-.432a.528.528 0 00.367-.25l1.208-2.061z",
    stroke: "#fff",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 17.237c-.962.488-2.05.763-3.204.763C6.155 18 3 14.866 3 11s3.155-7 7.046-7a7.043 7.043 0 016.755 5",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10 11a2 2 0 100-4 2 2 0 000 4z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14c.208-.344 1.024-1 2-1s1.792.656 2 1",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgCdp;